import {RecordingProcedure} from "@/shared/timrTypes";

/**
 * Defines type for html name attribute of input fields
 */
export type RecordingType = "workingTime" | "projectTime";

/**
 * Returns boolean if working time is involved for given recording procedure
 * @param procedure
 */
export function isWorkingTimeIncluded(procedure: RecordingProcedure): boolean {
	return procedure === RecordingProcedure.WorkingTime || procedure === RecordingProcedure.Both;
}

/**
 * Returns boolean if project time is involved for given recording procedure
 * @param procedure
 */
export function isProjectTimeIncluded(procedure: RecordingProcedure): boolean {
	return procedure === RecordingProcedure.ProjectTime || procedure === RecordingProcedure.Both;
}

/**
 * Helper method to get procedure enum for given recording type
 * @param type
 */
export function getModeForType(type: RecordingType): RecordingProcedure {
	switch (type) {
		case "workingTime":
			return RecordingProcedure.WorkingTime
		case "projectTime":
			return RecordingProcedure.ProjectTime
	}
}
